import styled from 'styled-components'
import Button from '@mui/material/Button'

// Media query breakpoints for consistency
const breakpoints = {
  mobile: '768px',
  desktop: '769px'
}

export const FieldGroupWrapper = styled.div`
  width: 600px;

  @media (max-width: ${breakpoints.mobile}) {
    width: 400px;
  }
`

// Fixed: Added missing box-shadow property
export const GridWrapper = styled.div`
  opacity: 0;
  animation: fadeIn 2s forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
  
  height: 450px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
`

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`

// Keeping original name for backward compatibility (typo: should be GridDiv)
export const GirdDiv = styled.div`
  position: relative;
  height: 100%;
  margin-top: 0;
`

// Also export with correct name for future use
export const GridDiv = GirdDiv

export const NoData = styled.div`
  margin: auto;
  font-weight: bold;
  font-size: 14px;
`

export const Warning = styled.div`
  width: 60px;
  height: 60px;
`

// Fixed: Corrected 'justify-items' to 'justify-content' for flexbox
export const AgGridNoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const SpinnerFlexLayoutWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: ${(props) => props.alignment || 'center'};
  justify-content: ${(props) => props.alignment || 'center'};
`

export const ListingGridTable = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px 20px 0 20px;
`

export const RedText = styled.div`
  color: red;
  font-size: 13px;
  text-align: left;
  margin-top: 4px;
  margin-left: 112px;
  margin-bottom: 8px;
`

export const ButtonPrimary = styled.button`
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  height: auto;
  padding: 0.5rem 1rem;
  font-weight: bold;
  background-color: #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease;
  border: none;
  border-radius: 4px;
  
  &:hover {
    background-color: #888888;
  }

  &:active {
    background-color: #555555;
    transform: scale(0.98);
  }

  &:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }

  &:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
`

export const FlatFieldSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  width: 100%;
  
  & > label {
    flex: 0 0 110px;
    margin: 0 12px 0 0;
    text-align: right;
    font-weight: normal;
    font-size: 14px;
    padding: 0;
  }
  
  & > :nth-child(2) {
    flex: 1;
  }

  input {
    font-size: 0.875rem;
    
    &::placeholder {
      color: #a8a8a7;
    }
  }
  
  .primaryInput {
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 26px 10px 12px;
    font-size: 16px;
    margin-left: 30px;
  }
`

export const Label = styled.label`
  color: black;
  text-align: right;
`

// Fixed: Removed duplicate cursor property and improved structure
export const InputStyle = styled.input`
  position: relative;
  flex: 1;
  width: 100%;
  height: 38px;
  margin: 0;
  padding: 6px 12px;
  font-size: 14px;
  background-color: ${(props) => (props.readOnly ? '#D3D3D3' : '#fff')}; 
  border-radius: 4px;
  border: 1px solid ${(props) => (props.error ? 'red' : '#ccc')};
  outline: 0;
  cursor: ${(props) => (props.readOnly ? 'not-allowed' : 'text')};
  color: ${(props) => (props.readOnly ? '#949494' : '#000')}; 
  box-sizing: border-box;

  &:focus {
    border-color: #001645;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`

export const DropDownStyle = styled.div`
  flex: 1;
  width: 180px;
  margin: 8px 8px 8px -18px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 4px;
  outline: 0;
  cursor: pointer;
`

// Improved with better color contrast and accessibility
export const PrimaryDropDownStyle = {
  option: (provided, state) => ({
    ...provided,
    textAlign: 'left',
    backgroundColor: state.isFocused ? '#e6f3ff' : 'white',
    color: state.isDisabled ? '#ccc' : 'black',
    border: '0',
    height: 'auto',
    minHeight: '40px',
    ':hover': {
      backgroundColor: state.isDisabled ? 'white' : '#e6f3ff',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    },
  }),
  control: (styles, state) => ({
    ...styles,
    boxShadow: 'none',
    borderWidth: '1px',
    borderColor: state.isFocused ? '#007bff' : '#a8a8a7',
    ':hover': {
      borderWidth: '1px',
      borderColor: state.isFocused ? '#007bff' : '#666',
      cursor: 'pointer',
    },
    ':focus': {
      borderWidth: '2px',
      borderColor: '#007bff',
      backgroundColor: '#f8f9fa',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#a8a8a7',
  }),
}

export const SpinnerBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`

export const SpinningButtonIconWrapper = styled.div`
  margin-left: 10px;
`

export const Tab = styled.button`
  font-size: 15px;
  font-weight: bold;
  padding: 10px 30px;
  cursor: pointer;
  opacity: 0.65;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  outline: 0;
  transition: all 0.2s ease;
  margin-bottom: -2px;
  
  &:hover {
    opacity: 0.9;
  }
  
  &:focus {
    outline: none;
  }
  
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #001645;
    color: #001645;
    opacity: 1;
  `}
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
  border-bottom: 2px solid #e8e8e8;
  width: 100%;
`

export const Container_top = styled.div`
  display: flex;
  
  .text-left {
    flex: 0 0 50%;
    display: flex;
    justify-content: flex-start;
    font-size: 20px;
    padding: 20px;
  }
  
  .text-right {
    flex: 0 0 50%;
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
  }
`

export const RadioContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  .container {
    display: flex;
    gap: 10px;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
    position: relative;
    left: 11px;
    margin-bottom: 10px;
  }

  .label {
    margin-right: 10px;
  }

  .radio-option {
    gap: 4px;
    display: flex;
    align-items: center;
  }

  .radio-input {
    margin-right: 8px;
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: absolute;
  top: 240px;
  left: 0;
  right: 0;
  bottom: 0;
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: max-content;
  background: white;
  padding: 60px;
  border-radius: 10px;
  position: relative;
  font-weight: bold;
  color: black;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
`

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background-color: #ffebee;
  }
  
  &:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`

export const NotificationWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  border-radius: 5px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => (props.type === 'success' ? '#28a745' : '#dc3545')};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1001;
  max-width: 400px;
  word-wrap: break-word;
`

export const NotificationCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
  color: white;
  padding: 2px 6px;
  border-radius: 2px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  
  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
  }
`

export const StyledButton = styled(Button)`
  && {
    margin-left: 20px;
    margin-right: ${({ marginRight }) => marginRight || '0px'};
    width: ${({ width }) => width || 'max-content'};
    color: ${({ textColor }) => textColor || 'white'};
    background-color: ${({ buttonColor }) => buttonColor || 'black'};
    border: ${({ border }) => border || 'none'};
  }
`

export const MolViewerDiv = styled.div`
  position: relative;
  width: 500px;
  height: 500px;
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: ${breakpoints.mobile}) {
    width: 300px;
    height: 300px;
  }
`

// Fixed: Corrected media query logic
export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;
  padding: 10px;

  @media (max-width: ${breakpoints.mobile}) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-left: 2px;
  gap: 20px;
  width: 100%;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    gap: 10px;
    margin-top: 100px;
  }
`

export const DownloadPdbBox = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    position: relative;
    width: 300px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    margin-right: 20px;
  }

  .btn-primary {
    width: 300px;
    background-color: #f5f5f5;
    color: black;
  }
`

export const LoadingSkeleton = styled.span`
  animation: pulse 2s infinite;
  font-size: 20px;
  font-style: italic;
  
  @keyframes pulse {
    0%, 100% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
  }
`

export const EmailMessageContainer = styled.div`
  display: flex;
  padding: 3rem 1rem;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #001645;

  @media (min-width: 640px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

export const EmailLoaderLayout = styled.div`
  padding: 2rem;
  margin-top: 2rem;
  border-radius: 0.5rem;
  width: 100%;
  max-width: 28rem;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
`

export const EmailLoader = styled.div`
  text-align: center;

  .loading-icon {
    margin: auto;
    border-radius: 50%;
    border: 2px solid transparent;
    border-bottom-color: #001645;
    width: 3rem;
    height: 3rem;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .h2-loader {
    margin-top: 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
    color: #111827;
  }
`

export const EmailSuccess = styled.div`
  text-align: center;
  
  .success-tick {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    background-color: #D1FAE5;
  }
  
  .svg-success {
    height: 1.5rem;
    width: 1.5rem;
    color: #001645;
  }
  
  .h2-success {
    margin-top: 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
    color: #111827;
  }
  
  .p-success {
    margin-top: 0.5rem;
    color: #4B5563;
  }
  
  .btn-login {
    margin-top: 1.5rem;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    border-width: 1px;
    border-color: transparent;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    color: #ffffff;
    background-color: #001645;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: background-color 0.3s ease;
    
    &:hover {
      background-color: #1D4ED8;
    }
    
    &:focus {
      outline: 2px solid #007bff;
      outline-offset: 2px;
    }
  }
`

export const EmailError = styled.div`
  text-align: center;
  
  .error-tick {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    background-color: #FEE2E2;
  }

  .svg-error {
    height: 1.5rem;
    width: 1.5rem;
    color: #001645;
  }

  .h2-error {
    margin-top: 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
    color: #111827;
  }

  .p-error {
    margin-top: 0.5rem;
    color: #4B5563;
  }

  .btn-login {
    display: flex;
    padding: 0.5rem 1rem;
    margin-top: 1.5rem;
    justify-content: center;
    border-radius: 0.375rem;
    border-width: 1px;
    border-color: transparent;
    width: 100%;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    color: #ffffff;
    background-color: #001645;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #1D4ED8;
    }
    
    &:focus {
      outline: 2px solid #007bff;
      outline-offset: 2px;
    }
  }
`

export const LoadingSpinnerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1000;
`

export const LoadingSpinner = styled.div`
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1.5s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const ResetPasswordDiv = styled.div`
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
  margin: auto;
  padding-bottom: 15px;

  button {
    background: none;
    border: none;
    color: #5f5f5f;
    text-decoration: none;
    cursor: pointer;
    font-size: small;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      color: #1976d2;
      text-decoration: underline;
      background-color: rgba(25, 118, 210, 0.1);
    }

    &:focus {
      outline: 2px solid #007bff;
      outline-offset: 2px;
    }
  }
`

export const SetupMfaDiv = styled.div`
  text-align: center;
`
